// extracted by mini-css-extract-plugin
export default {"root":"breadcrumbs_root__A67f4","breadcrumbs":"breadcrumbs_breadcrumbs__sA9UE","headerMobile":"breadcrumbs_headerMobile__rhML8","avatar":"breadcrumbs_avatar__HU-WI"};